// @flow
import { get } from 'lodash';
import { CommonMapper } from 'mappers/common';
import { EventMapper } from 'mappers/event';
import { EventDetails } from 'mappers/eventDetail';
import { EventActionTypes } from './actionTypes';

const getUpcomingEvents = () => (dispatch, getState, { api }) => {
  dispatch({
    type: EventActionTypes.UPCOMING.FETCH,
    payload: {},
    test: api
      .post(`getEvents.json`, { flag: 'upcoming' })
      .then(res => {
        const response = get(res, 'data.result.data', {});
        const mediaPath = CommonMapper.extractMediaPath(response);
        const events = response.music_events || [];
        dispatch({
          type: EventActionTypes.UPCOMING.SUCCESS,
          payload: EventMapper.mapEvents(events, mediaPath),
        });
        dispatch({
          type: EventActionTypes.OVERLAY_DATA.SUCCESS,
          payload: EventMapper.mapUpcomingOverlayEvents(events, mediaPath),
        });
        dispatch({
          type: EventActionTypes.UPCOMING_EVENT_FILTERS.INITIALIZE,
          payload: EventMapper.mapEventFilters(
            response,
            response.artist_media_path,
            response.device
          ),
        });
      })
      .catch(error => {
        dispatch({
          type: EventActionTypes.UPCOMING.FAILURE,
          error,
        });
      }),
  });
};

const getPastEvents = () => (dispatch, getState, { api }) => {
  dispatch({
    type: EventActionTypes.PAST.FETCH,
    payload: {},
    test: api
      .post(`getEvents.json`, { flag: 'past' })
      .then(res => {
        const response = get(res, 'data.result.data', {});
        const mediaPath = CommonMapper.extractMediaPath(response);
        const events = response.music_events || [];
        dispatch({
          type: EventActionTypes.PAST.SUCCESS,
          payload: EventMapper.mapPastEvents(events, mediaPath),
        });
        dispatch({
          type: EventActionTypes.PAST_EVENT_FILTERS.INITIALIZE,
          payload: EventMapper.mapEventFilters(
            response,
            response.artist_media_path,
            response.device
          ),
        });
      })
      .catch(error => {
        dispatch({
          type: EventActionTypes.PAST.FAILURE,
          error,
        });
      }),
  });
};

const getAllEvents = () => (dispatch, getState, { api }) => {
  dispatch({
    type: EventActionTypes.ALL.FETCH,
    payload: {},
    test: api
      .post(`getEvents.json`)
      .then(res => {
        const response = get(res, 'data.result.data', {});
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: EventActionTypes.ALL.SUCCESS,
          payload: response,
        });
        dispatch({
          type: EventActionTypes.EVENT_FILTERS.INITIALIZE,
          payload: EventMapper.mapEventFilters(
            response,
            response.artist_media_path,
            response.device
          ),
        });
      })
      .catch(error => {
        dispatch({
          type: EventActionTypes.ALL.FAILURE,
          error,
        });
      }),
  });
};

const getGalleryForEvent = () => (dispatch, getState, { api }) => {
  dispatch({
    type: EventActionTypes.GALLERY.FETCH,
    payload: {},
    test: api
      .post(`galleries.json`, {
        model: 'Music & Event Venue',
      })
      .then(res => {
        const response = res.data.data || {};
        const galleryImages = response.galleries || [];
        const mediaPath = CommonMapper.extractMediaPath(response);

        dispatch({
          type: EventActionTypes.GALLERY.SUCCESS,
          payload: CommonMapper.mapGalleryImages(galleryImages, mediaPath),
        });

        return res.data;
      })
      .catch(error => {
        dispatch({
          type: EventActionTypes.GALLERY.FAILURE,
          error,
        });
      }),
  });
};

const getArtistsAndGenres = () => (dispatch, getState, { api }) => {
  dispatch({
    type: EventActionTypes.ARTISTS_GENRES.FETCH,
    payload: {},
    test: api
      .post(`getArtistsAndGenres.json`)
      .then(res => {
        const response = get(res, 'data.data', {});
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: EventActionTypes.ARTISTS_GENRES.SUCCESS,
          payload: response,
        });
      })
      .catch(error => {
        dispatch({
          type: EventActionTypes.ARTISTS_GENRES.FAILURE,
          error,
        });
      }),
  });
};

const togglePastEventFilter = (type, value) => dispatch => {
  dispatch({
    type: EventActionTypes.PAST_EVENT_FILTERS.TOGGLE_FILTER,
    payload: {
      type,
      value,
    },
  });
};

const clearPastEventFilters = () => dispatch => {
  dispatch({
    type: EventActionTypes.PAST_EVENT_FILTERS.CLEAR_FILTERS,
  });
};

const toggleUpcomingEventFilter = (type, value) => dispatch => {
  dispatch({
    type: EventActionTypes.UPCOMING_EVENT_FILTERS.TOGGLE_FILTER,
    payload: {
      type,
      value,
    },
  });
};

const clearUpcomingEventFilters = () => dispatch => {
  dispatch({
    type: EventActionTypes.UPCOMING_EVENT_FILTERS.CLEAR_FILTERS,
  });
};

const getEventDetails = url_slug => (dispatch, getState, { api }) => {
  dispatch({
    type: EventActionTypes.BANNER.FETCH,
    payload: {},
    test: api
      .post(`getEventDetails.json`, { url_slug })
      .then(res => {
        const response = get(res, 'data.data.eventDetails', {});
        const mediaPath = CommonMapper.extractMediaPath(res.data.data);
        const artistMediaPath = get(res, 'data.data.artist_media_path', '');
        dispatch({
          type: EventActionTypes.BANNER.SUCCESS,
          payload: EventDetails.mapBanner(response, mediaPath),
        });
        dispatch({
          type: EventActionTypes.EVENT_ARTIST_DETAILS.FETCH,
          payload: EventDetails.mapEventArtist(response, artistMediaPath),
        });
      })
      .catch(error => {
        dispatch({
          type: EventActionTypes.BANNER.FAILURE,
          error,
        });
      }),
  });
};

const manageStandingTicketCount = value => dispatch => {
  dispatch({
    type: EventActionTypes.EVENT_TICKETS.STANDING,
    payload: value,
  });
};

const manageTableTickets = value => dispatch => {
  dispatch({
    type: EventActionTypes.EVENT_TICKETS.TABLE_BOOKING,
    payload: { tableData: value },
  });
};

//The action is used to get the tables-data for any given outlet_id
const getOutletEventTables = outlet_id => (dispatch, getState, { api }) => {
  dispatch({
    type: EventActionTypes.OUTLET_SEATING.FETCH,
    payload: {},
    test: api
      .post(`getOutletSeating.json`, { outlet_id })
      .then(res => {
        const response = get(res, 'data.data', {});
        dispatch({
          type: EventActionTypes.OUTLET_SEATING.SUCCESS,
          payload: EventDetails.mapOutletSeating(response.OutletSeating),
        });
      })
      .catch(error => {
        dispatch({
          type: EventActionTypes.OUTLET_SEATING.FAILURE,
          error,
        });
      }),
  });
};

//The action is used to get the number of booked standing tickets for any given event at a particular time.
const getBookedStandingTickets = event_time_id => (
  dispatch,
  getState,
  { api }
) => {
  dispatch({
    type: EventActionTypes.EVENT_STANDING_CAPACITY_STATUS.FETCH,
    payload: {},
    test: api
      .post(`getStandingTicketsBooked.json`, {
        music_event_date_id: event_time_id,
      })
      .then(res => {
        const response = res.data.ticketsBooked ? res.data.ticketsBooked : 0;
        dispatch({
          type: EventActionTypes.EVENT_STANDING_CAPACITY_STATUS.SUCCESS,
          payload: response,
        });
      })
      .catch(error => {
        dispatch({
          type: EventActionTypes.EVENT_STANDING_CAPACITY_STATUS.FAILURE,
          error,
        });
      }),
  });
};

//The action is used to get the booked tables for any given event at a particular time.
const getBookedTables = event_time_id => (dispatch, getState, { api }) => {
  dispatch({
    type: EventActionTypes.EVENT_BOOKED_TABLES.FETCH,
    payload: {},
    test: api
      .post(`getBookedTablesForEvent.json`, {
        music_event_date_id: event_time_id,
      })
      .then(res => {
        let response = res.data.outletTables ? res.data.outletTables : [];
        dispatch({
          type: EventActionTypes.EVENT_BOOKED_TABLES.SUCCESS,
          payload: response,
        });
      })
      .catch(error => {
        dispatch({
          type: EventActionTypes.EVENT_BOOKED_TABLES.FAILURE,
          error,
        });
      }),
  });
};

export const EventActions = {
  getUpcomingEvents,
  getPastEvents,
  getGalleryForEvent,
  getAllEvents,
  togglePastEventFilter,
  clearPastEventFilters,
  toggleUpcomingEventFilter,
  clearUpcomingEventFilters,
  getArtistsAndGenres,
  getEventDetails,
  manageStandingTicketCount,
  manageTableTickets,
  getOutletEventTables,
  getBookedStandingTickets,
  getBookedTables,
};
